
import { hmac as nobleHmac } from "@noble/hashes/hmac.js";
import { pbkdf2 as noblePbkdf2 } from "@noble/hashes/pbkdf2.js";
import { sha512 } from "@noble/hashes/sha2.js";
import { Buffer } from "buffer";

export function hmacSha512(key: Uint8Array, data: Uint8Array): Buffer {
    return Buffer.from(nobleHmac(sha512, key, data));
}

export function pbkdf2Sha512(
    password: Uint8Array,
    salt: Uint8Array,
    iterations: number,
    dkLen: number
): Buffer {
    return Buffer.from(noblePbkdf2(sha512, password, salt, { c: iterations, dkLen }));
}
